import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>© 2026 digitalavatar — Crafting digital identities for the future</p>
    </footer>
  );
};

export default Footer;
